import { Vector3 } from "core/Maths/math.vector";
import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a Length product between 2 vectors
 */
export class RewardLengthBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("vector", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("length", RewardGraphConnectionPointTypes.Float);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardLengthBlock";
    }

    public get vector(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get length(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.vector.isConnected) {
            this.length._storedFunction = null;
            this.length._storedValue = null;
            return;
        }

        this.length._storedFunction = (state) => {
            const vec = this.vector.getConnectedValue(state) as Vector3;
            return vec.length();
        };

        return this;
    }
}

RegisterClass("MELS.RewardLengthBlock", RewardLengthBlock);
